import { LinearLoading } from 'common'
// import { DepositTable } from '../DepositTable/DepositTable'


// import { ModalModule } from '../MoldaDeposit'
import { Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle, Plus } from 'react-feather'
import { ModalModule } from '../Modal'
import { CollateralTable } from './CollateralTable'


export const FormStepCollateral = ({useFetchInit}) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { stepApplilication, formOpeningMode } = globalStates

    const { handleClickReturnStep, handleClickNextStep, handleClickShowModal } = Actions

return (
    <div className='content'>
        {/* {loadingFetchDeposits && ( <LinearLoading /> )} */}
        <CollateralTable useFetchInit = {useFetchInit}/>

        <ModalModule useFetchInit={useFetchInit} />
        <div className="text-center">
            {stepApplilication !== 0 && (
                <Button 
                    startIcon={<ArrowLeftCircle/>}
                    variant="contained"
                    type="button" 
                    className='btn-round'
                    color='warning'
                    onClick={handleClickReturnStep} 
                    sx={{ marginTop:2, marginRight: 1, marginLeft:    1 }}
                >
                    Volver
                </Button>
            )}

                <Button
                    endIcon={<ArrowRightCircle/>}
                    variant="contained"
                    type="button"
                    className='btn-round'
                    color='primary'
                    sx={{marginTop:2,  marginRight: 1, marginLeft: 1 }}
                    onClick={handleClickNextStep}
                >       
                    {stepApplilication === 4 ? 'Finalizar' : 'Continuar'}
                </Button>
        </div>
    </div>
)
}